export let StackAlignment = /*#__PURE__*/function (StackAlignment) {
  StackAlignment["Left"] = "left";
  StackAlignment["Center"] = "center";
  return StackAlignment;
}({});
export default StackAlignment;